import Colors from "./color";
import Colors2 from "./color2";
import { TEMPLATENAME, setTemplateName, setTheme, store } from "./store";

export type COLORS = typeof Colors.light;
function useThemes() {
  const { theme, template } = store.useState();

  const dispatch = store.useDispatch();
  const isLight = theme === "light";
  const whatsTheme = template === "01" ? Colors : Colors2;
  const colors = isLight ? whatsTheme.dark : whatsTheme.light; // Corrected the order of colors
  function changeTheme() {
    dispatch(setTheme(isLight ? "dark" : "light"));
  }
  function changeTemplate(value: TEMPLATENAME) {
    dispatch(setTemplateName(value));
  }
  return { colors, isLight, name: theme, changeTheme, changeTemplate,template };
}

export { useThemes };
